import React, { Component } from 'react';
import FontAwesome from 'react-fontawesome';
import { apiService } from '../../../common/apiCallService.js'
import { domain, facebook_appId, baseUrl, partyBrands } from '../../../common/config.js';
import { saveActivity } from '../../../common/commonService.js'

import './ReplayerShareDialog.css';
import copy from 'copy-to-clipboard';
import i18next from 'i18next'
import { connect } from 'react-redux';
let bannerImageForDisplay = `/images/social-banners/PartyPoker/replayer/share_replayer_banner.jpg`;

let loggedInType = 'PartyPoker';
class ReplayerShareDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // title: 'Select image to share',
            // stage: 1,
            // imageList: [
            //     `https://${domain}/images/social-banners/replayer/emoji-1.jpg`,
            //     `https://${domain}/images/social-banners/replayer/emoji-2.jpg`,
            //     `https://${domain}/images/social-banners/replayer/emoji-3.jpg`,
            //     `https://${domain}/images/social-banners/replayer/emoji-4.jpg`,
            // ],
            // selectedImage: 0,
            shareId: '',
            shareLink: '',
            copiedLink: "",
            fetchingShareData: false,
            shareToMoment: true
        }
    }

    saveShareHand = (shareToMomentFlag, listOfHands) => {
        console.log("inside replayer share dialogue");
        //if (localStorage.getItem("loggedInType") === "Danskespil") {
            if (!partyBrands.includes(localStorage.getItem("loggedInType"))) {
            bannerImageForDisplay = `/images/social-banners/Danskespil/replayer/share_replayer_banner.jpg`;
            loggedInType = 'Danskespil';
        }
        // if(this.props !== prevProps) {
            //const bannerImage = `https://${domain}` + `/images/social-banners/${loggedInType}/replayer/share_replayer_banner.jpg`
            const bannerImage = `https://${domain}` + (partyBrands.includes(localStorage.getItem("loggedInType"))?(`/images/social-banners/PartyPoker/replayer/share_replayer_banner.jpg`):(`/images/social-banners/Danskespil/replayer/share_replayer_banner.jpg`))
            if(domain && this.state.shareLink === '' && !this.state.fetchingShareData){
                this.onClick_emoji(bannerImage, shareToMomentFlag, listOfHands);
                this.setState({ fetchingShareData: true, shareToMoment: false })
            }
        // }
    }
    shareOnFaceBook = () => {
        const { shareLink, shareId } = this.state;
        // console.log("========shareonFB==========")
        // console.log("=======this.props.facebook_appId============")
        // console.log(this.props.facebook_appId)
        // console.log("===========shareLink==========")
        // console.log(shareLink)
        saveActivity({
            hit_page: 'HandReplayer',
            hit_type: 'ReplayerShared',
            hit_attribute1: this.props.gameTypeForTitle,
            hit_attribute2: this.props.gameNo,
            hit_attribute3: this.props.accountName,
            hit_attribute4: shareId,
            hit_attribute5: 'facebook',
        })
        // console.log(`https://www.facebook.com/dialog/share?app_id=${facebook_appId}&display=popup&href=${encodeURIComponent(shareLink + '&source=facebook')}`);

        if(window.messageToNative || (window.external && window.external.NativeDispatch)){
            window.open(
            `https://www.facebook.com/dialog/share?app_id=${facebook_appId}&display=popup&href=${encodeURIComponent(shareLink + '&source=facebook')}`,
            '_blank'
        )}else{
            window.open(
                `https://www.facebook.com/dialog/share?app_id=${facebook_appId}&display=popup&href=${encodeURIComponent(shareLink + '&source=facebook')}`,
                '_blank',
                'width=600,height=400'
            )
        }
        this.closeDialog();
    }

    closeDialog = () => {
        this.props.onClose();
    }
    shareToMoment = () =>{
        this.saveShareHand(true)
    }
    shareFullHand = () =>{
        this.saveShareHand(false)
    }
    shareMultipleHands = (listOfHands) => {
        this.saveShareHand(false, listOfHands)
    }
    shareOnTwitter = () => {
        const { shareLink, shareId } = this.state;
        saveActivity({
            hit_page: 'HandReplayer',
            hit_type: 'ReplayerShared',
            hit_attribute1: this.props.gameTypeForTitle,
            hit_attribute2: this.props.gameNo,
            hit_attribute3: this.props.accountName,
            hit_attribute4: shareId,
            hit_attribute5: 'twitter'
        })
        if (window.messageToNative || (window.external && window.external.NativeDispatch)) {
            window.open(
                `https://twitter.com/share?url=${encodeURIComponent(shareLink + '&source=twitter')}&&text=check out this hand&&via=partypoker`,
                '_blank'
            )
        } else {
            window.open(
                `https://twitter.com/share?url=${encodeURIComponent(shareLink + '&source=twitter')}&&text=check out this hand&&via=partypoker`,
                '_blank',
                'width=600,height=400'
            )
        }
        this.closeDialog();
    }

    onClick_emoji = (emoji, shareToMomentFlag, listOfHands) => {
        console.log("emoji",emoji);
        if (listOfHands) {
            listOfHands = listOfHands.map(handObj=>{
                delete handObj.notes;
                return handObj;
            })
        }
        const {
            smallBlind,
            bigBlind,
            gameNo,
            accountName,
            gameTypeForTitle,
            partitionDate,
            slideIndex,
            loggedInType
        } = this.props;
        console.log("slideIndex",slideIndex);
        // const {
        //     selectedImage,
        //     imageList
        // } = this.state;
        //const bannerImage = `https://${domain}` + `/images/social-banners/${loggedInType}/replayer/share_replayer_banner.jpg`
        const bannerImage = `https://${domain}` +(partyBrands.includes(localStorage.getItem("loggedInType"))?(`/images/social-banners/PartyPoker/replayer/share_replayer_banner.jpg`):(`/images/social-banners/Danskespil/replayer/share_replayer_banner.jpg`))
        // console.log("domain>>>>>>>",domain)
        // console.log("bannerImage>>>>>>",bannerImage)
        apiService(
            baseUrl + '/shareLinkMetadata/save',
            {
                type: 'Replayer',
                // banner_url: imageList[selectedImage],
                banner_url: bannerImage,
                title: `Cash Game - ${smallBlind}/${bigBlind} - Replay Now!`,
                description: `partypoker's free poker coach is here to take your game to the next level`,
                attribute1: gameTypeForTitle,
                attribute2: listOfHands && listOfHands.length > 0 ? JSON.stringify(listOfHands) : gameNo,
                attribute3: accountName,
                attribute4: partitionDate,
                attribute5: shareToMomentFlag ? slideIndex : 0,
                attribute6: loggedInType || 'PartyPoker'
            },
            ({ _id: shareId }) => {
                let gameNo = this.props.gameNo;
                if (listOfHands && listOfHands.length > 0) {
                    let gameNo = "";
                    listOfHands.map(handObj => {
                        gameNo += (", " + handObj.gameNo.toString());
                    })
                }
                saveActivity({
                    hit_page: 'HandReplayer',
                    hit_type: 'ShareModalOpen',
                    hit_attribute1: this.props.gameTypeForTitle,
                    hit_attribute2: gameNo,
                    hit_attribute4: shareId
                })
                this.setState(
                    {
                        shareId,
                        shareLink: `https://${domain}/share/replayer?id=${shareId}`,
                        // stage: 2,
                        // title: 'Share To'
                    }
                )
            },
            console.error
        )
    }
    Header = props => {
        return (
            <div className='report-share-modal-header'>
                {/* {props.showBackButton ?
                    <button className='report-share-modal__back' onClick={this.goBack}>
                        <FontAwesome className='centre' name='fas fa-arrow-left' />
                    </button> :
                    <div style={{width: "40px"}}></div>
                } */}
                <b className='report-share-modal__content'>{i18next.t("lable.shareTo")}:</b>
                <button className='report-share-modal__close' onClick={this.closeDialog} style={{ marginRight: '20px', marginTop: '5px' }}>
                    <FontAwesome data-e2e="close" className='centre' name='fas fa-times'/>
                </button>
            </div>
        )
    }

    SelectSocialMedia = props => {
        return (
            <div className=''>
                <button className='btn social-btn btnHalo sm-btn share-buttons-social' style={{ backgroundColor: "#3A5998" }} onClick={this.shareOnFaceBook} >
                    <FontAwesome className='social-btn__logo' name='fab fa-facebook-f' />
                    <span data-e2e="socialShareFacebook" className='social-btn__text'>Facebook</span>
                </button>
                <button className='btn social-btn btnHalo sm-btn share-buttons-social' style={{ backgroundColor: "#1EC5FF" }} onClick={this.shareOnTwitter}>
                    <FontAwesome className='social-btn__logo' name='fab fa-twitter' />
                    <span  data-e2e="socialShareTwitter" className='social-btn__text'>Twitter</span>
                </button>
                { this.state.shareId ? <button data-e2e="copyLink" className={`btnHalo btn social-btn share_copyButton share-buttons-social ${ this.state.copiedLink === "" ? "" : "share_copyButton_disable"}` } onClick={()=>{
                        const shareLink= `https://${domain}/share/replayer?id=${this.state.shareId}`;
                        // console.log(shareLink)
                    saveActivity({
                        hit_page: 'HandReplayer',
                        hit_type: 'ReplayerShared',
                        hit_attribute1: this.props.gameTypeForTitle,
                        hit_attribute2: this.props.gameNo,
                        hit_attribute3: this.props.accountName,
                        hit_attribute4: this.state.shareId,
                        hit_attribute5: 'copylink',
                    })
                        this.setState({copiedLink: shareLink})
                        copy(shareLink);
                    }}>
                 { this.state.copiedLink !== "" ? i18next.t("lable.linkCopied")  : i18next.t("lable.copyLink") }
                </button> : null }
            </div>
        )
    }

    // SelectEmoji = props => {
    //     return (
    //         <div className='gallery' >
    //             <span className="bannerChangeButton">
    //                 <FontAwesome className='centre' size='2x' name='fas fa-angle-left' onClick={this.prevImage} style={{ color: "#000000", fontWeight: '600' }} />
    //             </span>
    //             {props.imageList.map((image, key) => 
    //                 <img key={key} data-e2e="socialBanner" className='img-display' src={image} style={{display: (key === props.selectedImage) ? 'inline-block' : 'none'}} onClick={this.onClick_emoji} />
    //             )}
    //             <span className="bannerChangeButton">
    //                 <FontAwesome className='centre' size='2x' name='fas fa-angle-right' onClick={this.nextImage} style={{ color: "#000000", fontWeight: '600' }} />
    //             </span>
    //             <div className='radio-list'>
    //                 {props.imageList.map((image, key) =>
    //                     <div key={key}
    //                         onClick={_ => this.setState({ selectedImage: key })}
    //                         className={`slider ${props.selectedImage == key ? 'selected' : ''}`}
    //                     />
    //                 )}
    //             </div>
    //         </div>
    //     )
    // }
    render() {
        // const {
        //     title,
        //     stage,
        //     imageList,
        //     selectedImage
        // } = this.state;
        const { isOpen } = this.props;
        console.log("isOpen=====",isOpen);
        return (
            <div
                className={`rs-modal ${isOpen ? 'displayBlock' : 'displayNone'}`}
            >
                {/* {slideLength} */}
              {this.state.shareToMoment ? 
              <div style={{ display: 'grid', justifyItems: 'center' }}>
              <div className='fit-content report-share-modal-content shareToMomentDiv' style={{ background: 'white', borderRadius: '5px' }}>
                  <div className="shareToMomentCpntentDiv">
                    <div className="shareToMomentHeaderDiv">{i18next.t("lable.shareOptions")}<span style={{float:"right", cursor: "pointer"}}><i className="fa fa-times" onClick={() => this.closeDialog()}  data-e2e="shareCloseButton"></i></span></div>
                  <div className="share-up-to-a-specif">{i18next.t("lable.shareUpToSpecific")}.</div>
                  </div>
                  {console.log("(this.props.slideIndex >1 && this.props.slideIndex < (this.props.slideLength-1))",(parseInt(this.props.slideLength)-1),this.props.slideIndex,(this.props.slideIndex >1 && this.props.slideIndex < (this.props.slideLength-1)))}
                            {this.props.isMultipleHands &&
                                <button className='shareToMomentButton' onClick={() => this.shareMultipleHands(this.props.selectedHandList)} data-e2e="shareHandEnable">
                                    {i18next.t("lable.shareAllSession")}
                                </button>
                            }
                  {(this.props.slideIndex >1 && this.props.slideIndex < (this.props.slideLength-1))  ?
                  <button  className='shareToMomentButton'  onClick={() => this.shareToMoment()} data-e2e="shareHandEnable">
                    {i18next.t("lable.shareUpToThisMoment")}
                  </button>:
                  <button  className='shareToMomentButtonDisabled' data-e2e="shareHandDisable">
                    {i18next.t("lable.shareUpToThisMoment")}
                  </button>}
                  <button className='shareToMomentButton' onClick={() => this.shareFullHand()} data-e2e="shareFullHand">
                  {i18next.t("lable.shareFullHand")}
                  </button> 
              </div>
          </div>
             : <div style={{ display: 'grid', justifyItems: 'center' }}>
             <div className='fit-content report-share-modal-content shareToMomentDiv' style={{ background: 'white', borderRadius: '5px' }}>
             <div className="shareToMomentCpntentDiv">
                    <div className="shareToMomentHeaderDiv">{i18next.t("lable.shareOptions")}<span style={{float:"right"}}><i className="fa fa-times" data-e2e="shareClose" onClick={() => this.closeDialog()}></i></span></div>
                  <div className="share-up-to-a-specif">{i18next.t("lable.sharetoFbTwCl")}.</div>
                  </div>
                 <div>
                     {/* <this.Header 
                   />
                   <img data-e2e="socialBanner" className='img-display mygame_share_to_banner_image' src={bannerImageForDisplay} /> */}
                 <this.SelectSocialMedia />
                 </div>
             </div>
         </div>}  
                
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
      lang: state.header.lang
    }
  }
  
  export default connect(mapStateToProps, null)(ReplayerShareDialog);



/** WEBPACK FOOTER **
 ** ./src/components/HandReplayer/ReplayerShareDialog/ReplayerShareDialog.js
 **/